import { css } from "@emotion/core";
import { color } from "../../constants/commons";

export const feeContainerStyles = css`
  .card-container {
    background-color: ${color.whitishGray};
  }
  .payment-service-type {
  }
`;
